import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5 9.99992H15M15 9.99992L10.8333 5.83325M15 9.99992L10.8333 14.1666",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgArrowRight;
